module.exports = __webpack_public_path__ + "img/19.760f0d0b.png";